"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactIntl = require("react-intl");
var _browser = require("../../browser");
var _config = _interopRequireDefault(require("../../config"));
var _templateObject, _templateObject2;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var AmountInputContainer = _styledComponents["default"].div(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  @media screen and (max-width: 600px) {\n    padding-top: 5px;\n  }\n  display: flex;\n  align-items: center;\n"])));
var AmountInput = _styledComponents["default"].input(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n  width: 125px;\n  border-radius: 3px;\n  height: 25px;\n  border: 1px solid grey;\n  text-indent: 10px;\n\n  @media screen and (max-width: 600px) {\n    float: left;\n  }\n\n  ", "\n"])), function (props) {
  return props.error && "\n    border: 1px solid red;\n  ";
});
var AmountInputComponent = function (_PureComponent) {
  function AmountInputComponent() {
    return (0, _classCallCheck2["default"])(this, AmountInputComponent), _callSuper(this, AmountInputComponent, arguments);
  }
  return (0, _inherits2["default"])(AmountInputComponent, _PureComponent), (0, _createClass2["default"])(AmountInputComponent, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        defaultValue = _this$props.defaultValue,
        required = _this$props.required,
        formatMessage = _this$props.intl.formatMessage,
        _onChange = _this$props.onChange;
      return _react["default"].createElement(AmountInputContainer, null, _react["default"].createElement(_browser.CurrencySymbol, {
        contrasting: true
      }), _react["default"].createElement(AmountInput, {
        type: "number",
        required: required,
        min: required ? _config["default"].minAmount : null,
        defaultValue: defaultValue,
        onChange: function onChange(event) {
          return _onChange(event);
        },
        placeholder: formatMessage({
          id: 'htmPayment.amount.input.placeholder'
        })
      }));
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = (0, _reactIntl.injectIntl)(AmountInputComponent);